import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { CheckCircle, XCircle } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function TargetAudience() {
  const forYou = ['Quieres ingresos digitales reales', 'Estás dispuesto a ejecutar', 'Quieres crear activos digitales', 'Buscas monetizar rápido', 'No sabes qué vender pero quieres empezar'];
  const notForYou = ['Esperas dinero sin acción', 'Buscas solo teoría sin práctica', 'No quieres aprender a vender', 'Buscas fórmulas mágicas sin trabajo'];
  return <section className="py-20 px-4 bg-[#0a0a1f]" data-id="element-332">
      <div className="container mx-auto max-w-6xl" data-id="element-333">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-334">
          <ScrollReveal direction="left" className="h-full" data-id="element-335">
            <div className="glass-card p-8 rounded-3xl h-full border border-green-500/20 bg-green-900/5" data-id="element-336">
              <h3 className="text-2xl font-bold mb-6 text-green-400 flex items-center gap-2" data-id="element-337">
                <CheckCircle className="w-6 h-6" data-id="element-338" />
                Este programa es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-339">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-340">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-341" />
                    <span className="text-gray-300" data-id="element-342">{item}</span>
                  </li>)}
              </ul>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" className="h-full" data-id="element-343">
            <div className="glass-card p-8 rounded-3xl h-full border border-red-500/20 bg-red-900/5" data-id="element-344">
              <h3 className="text-2xl font-bold mb-6 text-red-400 flex items-center gap-2" data-id="element-345">
                <XCircle className="w-6 h-6" data-id="element-346" />
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-347">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-348">
                    <XCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-349" />
                    <span className="text-gray-300" data-id="element-350">{item}</span>
                  </li>)}
              </ul>
            </div>
          </ScrollReveal>
        </div>

        <SectionCTA headline="¿Te identificas? Este es tu momento" buttonText="SÍ, QUIERO EMPEZAR — $16.39" data-id="element-351" />
      </div>
    </section>;
}